export const BRIGHCOVE_PLAYER_ID = 'QCRATd6KT';
export const BRIGHCOVE_TEST_PLAYER_ID = 'zptF8uM4YP';
